module.exports = __webpack_public_path__ + "img/08.7f518b0b.png";